import { createSelector } from 'reselect';

import getNavigationSlice from '@/state/selectors/navigation/get-navigation-slice';

const getModels = createSelector([getNavigationSlice], ({ models }) => models);

export default getModels;
